/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Wd_View_ProfileInputs */

const en_wd_view_profile = /** @type {(inputs: Wd_View_ProfileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`View ${i?.name}'s GitHub profile`)
};

const ar_wd_view_profile = /** @type {(inputs: Wd_View_ProfileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`عرض ملف ${i?.name} على GitHub`)
};

const bn_wd_view_profile = /** @type {(inputs: Wd_View_ProfileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}-এর GitHub প্রোফাইল দেখুন`)
};

const de_wd_view_profile = /** @type {(inputs: Wd_View_ProfileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sehen Sie sich das GitHub-Profil von ${i?.name} an`)
};

const es_wd_view_profile = /** @type {(inputs: Wd_View_ProfileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ver el perfil de GitHub de ${i?.name}`)
};

const fr_wd_view_profile = /** @type {(inputs: Wd_View_ProfileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Afficher le profil GitHub de ${i?.name}`)
};

const pt_wd_view_profile = /** @type {(inputs: Wd_View_ProfileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ver o perfil GitHub de ${i?.name}`)
};

const zh_wd_view_profile = /** @type {(inputs: Wd_View_ProfileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`查看 ${i?.name} 的 GitHub 个人资料`)
};

const tr_wd_view_profile = /** @type {(inputs: Wd_View_ProfileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} adlı kullanıcının GitHub profilini görüntüleyin`)
};

const ru_wd_view_profile = /** @type {(inputs: Wd_View_ProfileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Посмотреть профиль пользователя ${i?.name} на GitHub`)
};

const pl_wd_view_profile = /** @type {(inputs: Wd_View_ProfileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wyświetl profil GitHub użytkownika ${i?.name}`)
};

/**
* | output |
* | --- |
* | "View {name}'s GitHub profile" |
*
* @param {Wd_View_ProfileInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const wd_view_profile = /** @type {((inputs: Wd_View_ProfileInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_View_ProfileInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_wd_view_profile(inputs)
	if (locale === "bn") return bn_wd_view_profile(inputs)
	if (locale === "de") return de_wd_view_profile(inputs)
	if (locale === "es") return es_wd_view_profile(inputs)
	if (locale === "fr") return fr_wd_view_profile(inputs)
	if (locale === "pt") return pt_wd_view_profile(inputs)
	if (locale === "zh") return zh_wd_view_profile(inputs)
	if (locale === "tr") return tr_wd_view_profile(inputs)
	if (locale === "ru") return ru_wd_view_profile(inputs)
	if (locale === "pl") return pl_wd_view_profile(inputs)
	return en_wd_view_profile(inputs)
});